<div class="cookie-notice-container max-w-550px p-3">
  <db-modal-header-default
    class="sticky-top"
    title="{{'FOOTER.' + getAppThemeName() + '.cookie_info.title' | translate}}"
  >
    <div class="db-modal-header-default__button">
      <language-menu color="" [iconOnly]="true"></language-menu>
    </div>
  </db-modal-header-default>

  <db-modal-content-default>
    {{'FOOTER.' + getAppThemeName() + '.cookie_info.body' | translate}}
    <a class="db-text" (click)="openPrivacyModal()">{{'FOOTER.' + getAppThemeName() + '.cookie_info.privacy_link' | translate}}</a>.
  </db-modal-content-default>

  <db-modal-footer-default class="sticky-bottom p-0" buttonPosition="right">
    <div class="footer-container">
      <db-button class="w-120px" size="md" (click)="onClickOK()" design="primary">{{'FOOTER.' + getAppThemeName() + '.cookie_info.button_1' | translate}}</db-button>
    </div>
  </db-modal-footer-default>
</div>
